// extracted by mini-css-extract-plugin
export default {"header":"Table_header__lHZUp","link":"Table_link__HLCsA","active":"Table_active__6xpkz","inactive":"Table_inactive__Ce3uI"};